export default IconLampOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-lamp-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M9 20h6" />
  <path d="M12 20v-8" />
  <path d="M7.325 7.35l-2.325 4.65h7m4 0h3l-4 -8h-6l-.338 .676" />
  <path d="M3 3l18 18" />
</svg>`;